export const BASE_API_DEV_URL = `https://${process.env.REACT_APP_BACKEND_URL}`
export const BASE_API_PROD_URL = `https://${process.env.REACT_APP_BACKEND_URL}`
export const WEB_SOCKET_URL = `wss://${process.env.REACT_APP_BACKEND_URL}ws`
